import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=366bb562&scoped=true&"
var script = {}
import style0 from "./navbar.vue?vue&type=style&index=0&id=366bb562&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366bb562",
  null
  
)

export default component.exports